import 'babel-polyfill'
import 'lib-flexible'
import Vue from 'vue'
import App from './app.vue'
import router from "./router/router";
import store from "./store/index"
import http from "./utils/http"
import utils from './utils/utils'
import txLogs from './utils/tencentLog'
import kpiRequest from './utils/kpiRequest'
import waterMark from './utils/watermark';
import { InitWXSDK } from './utils/wxconfig'
import './assets/public.css' 
// import './assets/slideApp.css'
import "./assets/less/common.less";
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';//引用字体css,显示默认图标字体

import {
  popup,
  Button,
  Loading, Overlay,
  Toast, NoticeBar, Field, Dialog, List, Icon, Col, Row, CellGroup, Cell, Popup, RadioGroup, Radio, Slider,
  Tabbar, TabbarItem, Tab, Tabs, Picker, Search, Collapse, CollapseItem, Tag, DatetimePicker,Divider,Checkbox, CheckboxGroup,Area
} from 'vant';
Vue.use(popup)
  .use(Button).use(Loading).use(Overlay).use(Toast).use(NoticeBar).use(Field).use(Dialog).use(List).use(Icon).use(Col).use(Row).use(CellGroup).use(Cell).use(Popup).use(RadioGroup).use(Radio).use(Tabbar).use(TabbarItem).use(Tab).use(Tabs).use(Picker).use(Search).use(Collapse).use(CollapseItem).use(Tag).use(DatetimePicker).use(Divider).use(Checkbox).use(Slider).use(CheckboxGroup).use(Area);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$utils = utils
Vue.prototype.$initWXSDK = InitWXSDK
Vue.prototype.$txLogs = txLogs
Vue.prototype.$kpi = kpiRequest
Vue.prototype.$wm = waterMark
// 原型对象方法拓展
import extend from './utils/extend.js';
Vue.use(extend)



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


// 滑块验证码方法
(function ($) {
  $.fn.imgcode = function (options) {
      //初始化参数
      var defaults = {
          frontimg: "",
          backimg: "",
          refreshImg: "",
          getsuccess: "",
          getfail: "",
          maskclose: true,
          callback: "",  //回调函数
          refreshcallback: "",
          closecallback: "",//滑块关闭事件
      };
      var opts = $.extend(defaults, options);
      return this.each(function () {
          var $this = $(this);//获取当前对象
          var html = '<div class="code-k-div">' +
              '<div class="code_bg"></div>' +
              '<div class="code-con">' +
              '<div class="code-img">' +
              '<div class="code-img-con">' +
              '<div class="code-mask"><img class="code-front-img" src="' + opts.frontimg + '"></div>' +
              '<img class="code-back-img" src="' + opts.backimg + '"></div>' +
              '<div class="code-push"><i class="icon-login-bg icon-w-25 icon-push">刷新</i><span class="code-tip"></span></div>' +
              '</div>' +
              '<div class="code-btn">' +
              '<div class="code-btn-img code-btn-m"></div>' +
              '<span class="code-span">按住滑块，拖动完成上方拼图</span>' +
              '</div></div></div>';
          $this.html(html);

          //定义拖动参数
          var $divMove = $(this).find(".code-btn-img"); //拖动按钮
          var $divWrap = $(this).find(".code-btn");//鼠标可拖拽区域
          var mX = 0, mY = 0;//定义鼠标X轴Y轴
          var dX = 0, dY = 0;//定义滑动区域左、上位置
          var isDown = false;//mousedown标记
          if (document.attachEvent) {//ie的事件监听，拖拽div时禁止选中内容，firefox与chrome已在css中设置过-moz-user-select: none; -webkit-user-select: none;
              $divMove[0].attachEvent('onselectstart', function () {
                  return false;
              });
          }
          //按钮拖动事件
          $divMove.unbind('mousedown').on({
              mousedown: function (e) {
                  //清除提示信息
                  $this.find(".code-tip").html("");
                  var event = e || window.event;
                  mX = event.pageX;
                  dX = $divWrap.offset().left;
                  dY = $divWrap.offset().top;
                  isDown = true;//鼠标拖拽启
                  $(this).addClass("active");
                  //修改按钮阴影
                  $divMove.css({ "box-shadow": "0 0 8px #666" });
              }
          });

          //移动端按钮touchstart事件
          $divMove.unbind('touchstart').on({
              touchstart: function (e) {
                  //清除提示信息
                  $this.find(".code-tip").html("");
                  var event = e || window.event;
                  mX = event.pageX;
                  dX = $divWrap.offset().left;
                  dY = $divWrap.offset().top;
                  isDown = true;//鼠标拖拽启
                  $(this).addClass("active");
                  //修改按钮阴影
                  $divMove.css({ "box-shadow": "0 0 8px #666" });
              }
          });

          //点击背景关闭
          if (opts.maskclose) {
              $this.find(".code_bg").unbind('click').click(function () {
                  $this.html("");
                  if (typeof (opts.closecallback) == "function") {
                      opts.closecallback();
                  }
              });
          }
          //刷新code码
          $this.find(".icon-push").unbind('click').click(function () {
              opts.refreshcallback();
          });
          //鼠标点击松手事件
          $divMove.unbind('mouseup').mouseup(function (e) {
              var lastX = $this.find(".code-mask").offset().left - dX - 1;
              isDown = false;//鼠标拖拽启
              $divMove.removeClass("active");
              //还原按钮阴影
              $divMove.css({ "box-shadow": "0 0 3px #ccc" });
              returncode(lastX);
          });

          //移动端按钮touchend事件
          $divMove.on('touchend', function (e) {
              var lastX = $this.find(".code-mask").offset().left - dX - 1;
              isDown = false;//鼠标拖拽启
              $divMove.removeClass("active");
              //还原按钮阴影
              $divMove.css({ "box-shadow": "0 0 3px #ccc" });
              returncode(lastX);
          });

          //滑动事件
          $divWrap.mousemove(function (event) {
              event = event || window.event;
              var x = event.pageX;//鼠标滑动时的X轴
              if (isDown) {
                  if (x > (dX + 30) && x < dX + $(this).width() - 20) {
                      $divMove.css({ "left": (x - dX - 20) + "px" });//div动态位置赋值
                      $this.find(".code-mask").css({ "left": (x - dX - 30) + "px" });
                  }
              }
          });

          //移动端按钮touchmove事件
          $divWrap.on('touchmove', function (event) {
              event = event || window.event;
              var x = event.originalEvent.changedTouches[0].pageX;//鼠标滑动时的X轴
              if (isDown) {
                  if (x > (dX + 30) && x < dX + $(this).width() - 20) {
                      $divMove.css({ "left": (x - dX - 20) + "px" });//div动态位置赋值
                      $this.find(".code-mask").css({ "left": (x - dX - 30) + "px" });
                  }
              }
          });

          //返回坐标系
          function returncode(xpos) {
              opts.callback({ xpos: xpos });
          }
          //验证数据
          function checkcode(code) {
              var iscur = true;
              //模拟ajax
              setTimeout(function () {
                  if (iscur) {
                      checkcoderesult(1, "验证通过");
                      $this.find(".code-k-div").remove();
                      opts.callback({ code: 1000, msg: "验证通过", msgcode: "23dfdf123" });
                  } else {
                      $divMove.addClass("error");
                      checkcoderesult(0, "验证不通过");
                      opts.callback({ code: 1001, msg: "验证不通过" });
                      setTimeout(function () {
                          $divMove.removeClass("error");
                          $this.find(".code-mask").animate({ "left": "0px" }, 200);
                          $divMove.animate({ "left": "10px" }, 200);
                      }, 300);
                  }
              }, 500);
          }
          //刷新图标
          opts.refreshImg = function (data) {
              $this.find(".code-img-con .code-front-img").attr("src", data.frontImg);
              $this.find(".code-img-con .code-back-img").attr("src", data.backGoundImg);
          };
          //验证成功
          opts.getsuccess = function () {
              checkcoderesult(1, "验证通过");
              setTimeout(function () {
                  $this.find(".code-k-div").remove();
              }, 800);

          };
          //验证失败
          opts.getfail = function (txt) {
              $divMove.addClass("error");
              checkcoderesult(0, txt);
              setTimeout(function () {
                  $divMove.removeClass("error");
                  $this.find(".code-mask").animate({ "left": "0px" }, 200);
                  $divMove.animate({ "left": "10px" }, 200);
              }, 400);
          };
          //验证结果
          function checkcoderesult(i, txt) {
              if (+i == 0) {
                  $this.find(".code-tip").addClass("code-tip-red");
              } else {
                  $this.find(".code-tip").addClass("code-tip-green");
              }
              $this.find(".code-tip").html(txt);
          }
      });
  };
})(jQuery);